import { render, staticRenderFns } from "./DayInCalendar.vue?vue&type=template&id=2a9ae9e6&"
import script from "./DayInCalendar.vue?vue&type=script&lang=js&"
export * from "./DayInCalendar.vue?vue&type=script&lang=js&"
import style0 from "./DayInCalendar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports